<div>
  <div>
    <div
      class="mb-2"
      [ngClass]="{ 'mx-4': !deepSearch }"
      [ngStyle]="isInventoryAttributesRoute ? { 'margin-top': '80px' } : {}"
    >
      <!-- <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">inventory</i>
        </div>
        <h4 class="card-title">{{ title }}</h4>
      </div> -->

      <div [ngClass]="{ 'mx-4': !deepSearch }">
        <div class="toolbar mb-4">
          <button class="select-btn" matButton [matMenuTriggerFor]="menu">
            <h2 class="card-label">
              <b>{{ sectionShownLabel }}</b>
            </h2>
            <mat-icon class="ml-2">keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              (click)="showContent('tree')"
              *ngIf="showSpecsTree"
              mat-menu-item
            >
              Tree Information
            </button>
            <button
              (click)="showContent('bitraser')"
              *ngIf="bitrasershow"
              mat-menu-item
            >
              Bitraser
            </button>
            <button
              (click)="showContent('phonecheck')"
              *ngIf="phonecheckinfo"
              mat-menu-item
            >
              Phone Check
            </button>
            <button
              (click)="showContent('eps')"
              *ngIf="attributesDataAvailable"
              mat-menu-item
            >
              EPS PXE
            </button>
          </mat-menu>
          <!--        Here you can write extra buttons/actions for the toolbar              -->
        </div>

        <mat-progress-bar
          style="width: 100%"
          *ngIf="loading"
          id="loadingbar"
          mode="indeterminate"
        >
        </mat-progress-bar>
        <div
          *ngIf="msgerror"
          id=""
          class="alert alert-danger mt-4 d-flex align-items-center"
          role="alert"
        >
          <i style="color: white" class="material-icons"> cancel </i>
          <span>
            {{ msgerror }}
          </span>
        </div>

        <!-- start Tree Information -->
        <div
          class="card card-body"
          *ngIf="showSpecsTree && sectionShown === 'tree'"
        >
          <h2 class="card-label mb-2">
            <b>{{ specsTree.masterCategory }}</b>
          </h2>
          <!-- <div class="row" style="border-top: 1px solid #ccc">
            <div class="col-md-12 border">
              <p style="margin-top: 6px">
                <b>{{ specsTree.masterCategory }}</b>
              </p>
            </div>
          </div> -->
          <div
            class="d-flex"
            style="border-top: 1px solid #ccc"
            *ngFor="let s of specsTree.children"
          >
            <div class="w-100 bg-main">
              <p>{{ s.spec }}</p>
            </div>
            <div class="w-100 p-2">
              <span class="readonly-input">
                {{ s.value }}
              </span>
            </div>
            <!-- <div class="col-md-6 bg-light border">
              <p style="margin-top: 6px">{{ s.spec }}</p>
            </div>
            <div class="col-md-6 border">
              <p style="margin-top: 6px">{{ s.value }}</p>
            </div> -->
          </div>
        </div>
        <!-- end Tree Information -->
        <!-- div eps -->
        <div *ngIf="attributesDataAvailable && sectionShown === 'eps'">
          <div [ngClass]="system?.length > 1 ? 'gridContainerTwo' : ''">
            <div class="card card-body" *ngFor="let s of system; let i = index">
              <div class="d-flex align-items-center mb-2">
                <h2 class="card-label">
                  <b>System Information:</b>
                </h2>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editModeo('system', true)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <app-button-primary
                  *ngIf="!editState.system"
                  (click)="saveAttributes(s, 'system', 0)"
                  label="Save Changes"
                  [primary]="true"
                  [iconLeft]="'save'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(s, 'system', 0)"
                  *ngIf="!disabled"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Manufacturer</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.manufacturer"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Model</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.model"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.serialnumber"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number New</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemSerialNumberNew{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.serialnumberNew"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
                <!--[value]="
                      s.serialnumberNew !== null
                        ? s.serialnumberNew
                        : s.serialnumber
                    "-->
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>SKU</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemSKU{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.sku"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Processor Information</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.field2"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Memory Information</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="systemField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.field3"
                    [readonly]="editState.system"
                    [class.readonly-input]="editState.system"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>PO and Line#</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="poline{{ i + 1 }}"
                    class="form-control fctrl readonly-input"
                    [(ngModel)]="poline"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>PO and Batch#</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batchline"
                    class="form-control fctrl readonly-input"
                    [(ngModel)]="batchline"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>MDM</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="mdm{{ i + 1 }}"
                    class="form-control fctrl readonly-input"
                    [(ngModel)]="mdm"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Computrace</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="computrace{{ i + 1 }}"
                    class="form-control fctrl readonly-input"
                    [(ngModel)]="computrace"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="deepSearch"
              >
                <div class="w-100 bg-main">
                  <p>Battery Health</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryHealth{{ i + 1 }}"
                    class="form-control fctrl readonly-input"
                    [(ngModel)]="batteryHealth"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="deepSearch"
              >
                <div class="w-100 bg-main">
                  <p>Battery Life</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryLife{{ i + 1 }}"
                    class="form-control fctrl readonly-input"
                    [(ngModel)]="batteryLife"
                    [readonly]="true"
                  />
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="hdds?.length > 1 ? 'gridContainerTwo' : ''">
            <div class="card card-body" *ngFor="let hdd of hdds; let i = index">
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>HDD #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('hdd', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.hdd"
                    (click)="saveAttributes(hdd, 'hdd', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                  <!-- <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="saveAttributes(hdd, 'hdd', 0)"
                    *ngIf="!disabled"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button> -->
                </div>
                <app-button-primary
                  (click)="remove(hdd, 'hdd')"
                  label="Remove Hard Drives #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(hdd, 'hdd')"
                
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Manufacturer</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddManufacturer"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Model</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddModel"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddSerialnumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddSerialnumber"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Capacity</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddCapacity{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddCapacity"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Block Size</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddBlocksize{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddBlocksize"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>RPM</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddRpm{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddRpm"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Form Factor</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddFormfactor{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddFormfactor"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Device Type</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddDevicetype{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddDevicetype"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Health Score</p>
                </div>
                <div class="w-100">
                  <!--<input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddHealthscore" [readonly] = "!editState.hdd">-->
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="90%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade A' ||
                      hdd.hddGrade === 'GRADE A' ||
                      hdd.hddGrade === 'Grade A-' ||
                      hdd.hddGrade === 'GRADE A-'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="80%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade B' ||
                      hdd.hddGrade === 'GRADE B' ||
                      hdd.hddGrade === 'Grade B-' ||
                      hdd.hddGrade === 'GRADE B-'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="70%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade C' ||
                      hdd.hddGrade === 'GRADE C' ||
                      hdd.hddGrade === 'Grade C-' ||
                      hdd.hddGrade === 'GRADE C-'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="60%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade D' ||
                      hdd.hddGrade === 'GRADE D' ||
                      hdd.hddGrade === 'Grade D-' ||
                      hdd.hddGrade === 'GRADE D-'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="1%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade E' || hdd.hddGrade === 'GRADE E'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="0%"
                    *ngIf="
                      hdd.hddGrade === 'Grade FAIL' ||
                      hdd.hddGrade === 'GRADE FAIL'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Grade</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddGrade{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddGrade"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Reallocated Sectors</p>
                </div>
                <div class="w-100">
                  <!--<input type="text" name="hddReallocatedsectors{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddReallocatedsectors" [readonly] = "!editState.hdd">-->
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="0"
                    *ngIf="
                      hdd.hddGrade === 'Grade A' ||
                      hdd.hddGrade === 'GRADE A' ||
                      hdd.hddGrade === 'Grade B' ||
                      hdd.hddGrade === 'GRADE B' ||
                      hdd.hddGrade === 'Grade C' ||
                      hdd.hddGrade === 'GRADE C' ||
                      hdd.hddGrade === 'Grade D' ||
                      hdd.hddGrade === 'GRADE D'
                    "
                    [class.readonly-input]="editState.hdd"
                  />

                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="5 MAX"
                    *ngIf="
                      hdd.hddGrade === 'Grade A-' ||
                      hdd.hddGrade === 'GRADE A-' ||
                      hdd.hddGrade === 'Grade B-' ||
                      hdd.hddGrade === 'GRADE B-' ||
                      hdd.hddGrade === 'Grade C-' ||
                      hdd.hddGrade === 'GRADE C-' ||
                      hdd.hddGrade === 'Grade D-' ||
                      hdd.hddGrade === 'GRADE D-'
                    "
                    [class.readonly-input]="editState.hdd"
                  />

                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="50 MAX"
                    *ngIf="
                      hdd.hddGrade === 'Grade E' || hdd.hddGrade === 'GRADE E'
                    "
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Power On Hours</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddPoweronhours{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddPoweronhours"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure Method</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddErasuremethod{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasuremethod"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure Results</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddErasureresults{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasureresults"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.hddErasureresults === 'PASSED',
                      'color-orange': hdd.hddErasureresults === 'PARTIAL',
                      'color-red': hdd.hddErasureresults === 'FAILED',
                      'color-red-d': hdd.hddErasureresults === 'DESTROYED',
                      'color-red-r': hdd.hddErasureresults === 'REMOVED',
                    }"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure 3rd Party Verification</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hdd3rdpartyverifify{{ i + 1 }}"
                    class="form-control fctrl in"
                    [(ngModel)]="hdd.hdd3rdpartyverifify"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.hdd3rdpartyverifify === 'PASSED',
                      'color-orange': hdd.hdd3rdpartyverifify === 'PARTIAL',
                      'color-red': hdd.hdd3rdpartyverifify === 'FAILED',
                      'color-red-d': hdd.hdd3rdpartyverifify === 'DESTROYED',
                      'color-red-r': hdd.hdd3rdpartyverifify === 'REMOVED',
                    }"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' || hdd.isDestroyed === '1'"
              >
                <div class="w-100 bg-main">
                  <p>Erasure Results (Before)</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="statusAnterior{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.statusAnterior"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.statusAnterior === 'PASSED',
                      'color-orange': hdd.statusAnterior === 'PARTIAL',
                      'color-red': hdd.statusAnterior === 'FAILED',
                      'color-red-d': hdd.statusAnterior === 'DESTROYED',
                      'color-red-r': hdd.statusAnterior === 'REMOVED',
                    }"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure Start Date</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddErasurestartdate{{ i + 1 }}"
                    class="form-control fctrl readonly-input"
                    readonly
                    [value]="hdd.hddErasurestartdate | date: 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure Start Time</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddErasurestarttime{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasurestarttime"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure End Date</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddErasureenddate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                    [value]="hdd.hddErasureenddate | date: 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Erasure End Time</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="hddErasureendtime{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasureendtime"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
              >
                <div class="w-100 bg-main">
                  <p>Destruction Date</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="destructionDate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                    [value]="hdd.destructionDate | date: 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
              >
                <div class="w-100 bg-main">
                  <p>Destruction Status</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="destructionStatus{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.destructionStatus"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
              >
                <div class="w-100 bg-main">
                  <p>Representative</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="userRemoved{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.userRemoved"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'"
              >
                <div class="w-100 bg-main">
                  <p>Drive Removed On</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="removedDate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                    [value]="hdd.removedDate | date: 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div
                class="d-flex"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'"
              >
                <div class="w-100 bg-main">
                  <p>Representative</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="userRemoved{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.userRemoved"
                    [readonly]="editState.hdd"
                    [class.readonly-input]="editState.hdd"
                  />
                </div>
              </div>
              <!--<div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>PO</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="hddPo{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddPo" [readonly] = "disabled">
                  </div>
                </div>-->
            </div>
          </div>

          <div [ngClass]="cpus?.length > 1 ? 'gridContainerTwo' : ''">
            <div class="card card-body" *ngFor="let cpu of cpus; let i = index">
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>CPU #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('cpu', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.cpu"
                    (click)="saveAttributes(cpu, 'cpu', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>

                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(cpu, 'cpu', 0)"
                  *ngIf="!!editState.cpu"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(cpu, 'cpu')"
                  label="Remove CPU #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(cpu, 'cpu')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Manufacturer</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="cpuManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.manufacturer"
                    [readonly]="editState.cpu"
                    [class.readonly-input]="editState.cpu"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Model</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="cpuModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.model"
                    [readonly]="editState.cpu"
                    [class.readonly-input]="editState.cpu"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="cpuSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.serialnumber"
                    [readonly]="editState.cpu"
                    [class.readonly-input]="editState.cpu"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Processor Speed</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="cpuField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.field1"
                    [readonly]="editState.cpu"
                    [class.readonly-input]="editState.cpu"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Processor Cores</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="cpuField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.field2"
                    [readonly]="editState.cpu"
                    [class.readonly-input]="editState.cpu"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Processor Type</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="cpuField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.field3"
                    [readonly]="editState.cpu"
                    [class.readonly-input]="editState.cpu"
                  />
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="memories?.length > 1 ? 'gridContainerTwo' : ''">
            <div
              class="card card-body"
              *ngFor="let memory of memories; let i = index"
            >
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>Memory #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('memory', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.memory"
                    (click)="saveAttributes(memory, 'memory', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(memory, 'memory', 0)"
                  *ngIf="!!editState.memory"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(memory, 'memory')"
                  label="Remove Memory #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(memory, 'memory')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Manufacturer</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="memoryManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.manufacturer"
                    [readonly]="editState.memory"
                    [class.readonly-input]="editState.memory"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Model</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="memoryModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.model"
                    [readonly]="editState.memory"
                    [class.readonly-input]="editState.memory"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="memorySerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.serialnumber"
                    [readonly]="editState.memory"
                    [class.readonly-input]="editState.memory"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Memory Size</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="memoryField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.field1"
                    [readonly]="editState.memory"
                    [class.readonly-input]="editState.memory"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Memory Speed</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="memoryField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.field2"
                    [readonly]="editState.memory"
                    [class.readonly-input]="editState.memory"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Memory Type</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="memoryType{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.memorytype"
                    [readonly]="editState.memory"
                    [class.readonly-input]="editState.memory"
                  />
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="testing?.length > 1 ? 'gridContainerTwo' : ''">
            <div
              class="card card-body"
              *ngFor="let t of testing; let i = index"
            >
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>Testing #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('testing', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.testing"
                    (click)="saveAttributes(t, 'testing', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(t, 'testing', 0)"
                  *ngIf="!disabled"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(t, 'testing')"
                  label="Remove Testing #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(t, 'testing')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <!--<div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Serial Number</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="testingSerialnumber{{i+1}}" class="form-control fctrl" [(ngModel)]="t.serialnumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Profile</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="testingProfile{{i+1}}" class="form-control fctrl" [(ngModel)]="t.profile" [readonly] = "disabled">
                  </div>
                </div>-->
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>CPU</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingCPU{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.cpu"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Memory</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingMemory{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.memory"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Battery</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingBattery{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.battery"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Missing Parts</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.field1"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Case Condition</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.field2"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Screen Condition</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.field3"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Display Resolution</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingDisplayResolution{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.displayResolution"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Optical Device</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="testingOpticalDevice{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.opticalDevice"
                    [readonly]="editState.testing"
                    [class.readonly-input]="editState.testing"
                  />
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="batteries?.length > 1 ? 'gridContainerTwo' : ''">
            <div
              class="card card-body"
              *ngFor="let battery of batteries; let i = index"
            >
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>Battery #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('battery', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.battery"
                    (click)="saveAttributes(battery, 'battery', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(battery, 'battery', 0)"
                  *ngIf="!disabled"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(battery, 'battery')"
                  label="Remove Battery #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(battery, 'battery')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Manufacturer</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.manufacturer"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Model</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.model"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batterySerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.serialnumber"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Battery Chemistry</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field1"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Battery Capacity</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field3"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Battery Full Charge</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryField4{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field4"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Battery Life</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="batteryField5{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field5"
                    [readonly]="editState.battery"
                    [class.readonly-input]="editState.battery"
                  />
                </div>
              </div>
              <!--<div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Battery Drain Test Results</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="batteryField7{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field7" [readonly] = "disabled">
                  </div>
                </div>-->
            </div>
          </div>

          <div [ngClass]="components?.length > 1 ? 'gridContainerTwo' : ''">
            <div
              class="card card-body"
              *ngFor="let component of components; let i = index"
            >
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>Component #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('component', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.component"
                    (click)="saveAttributes(component, 'component', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(component, 'component', 0)"
                  *ngIf="!disabled"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(component, 'component')"
                  label="Remove Component #{{ i + 1 }} "
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(component, 'component')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Manufacturer</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="componentManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="component.componentmanufacturer"
                    [readonly]="editState.component"
                    [class.readonly-input]="editState.component"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Model</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="componentModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="component.componentmodel"
                    [readonly]="editState.component"
                    [class.readonly-input]="editState.component"
                  />
                </div>
              </div>
              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Serial Number</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="componentSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="component.componentserialnumber"
                    [readonly]="editState.component"
                    [class.readonly-input]="editState.component"
                  />
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="networks?.length > 1 ? 'gridContainerTwo' : ''">
            <div
              class="card card-body"
              *ngFor="let network of networks; let i = index"
            >
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>Network Adapter #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('network', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.network"
                    (click)="saveAttributes(network, 'network', 0)"
                    label="Save Changes"
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(network, 'network', 0)"
                  *ngIf="!disabled"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(network, 'network')"
                  label="Remove Network #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(network, 'network')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Adapter</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="networkAdapter{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="network.networkadapter"
                    [readonly]="editState.network"
                    [class.readonly-input]="editState.network"
                  />
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="video?.length > 1 ? 'gridContainerTwo' : ''">
            <div class="card card-body" *ngFor="let v of video; let i = index">
              <div class="flex-container-between mb-2">
                <div class="d-flex align-items-center">
                  <h2 class="card-label">
                    <b>Video Adapter #{{ i + 1 }} Information:</b>
                  </h2>
                  <button
                    class="btn btn-sm btn-link btn-primary btn-just-icon"
                    (click)="editModeo('video', true)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-button-primary
                    *ngIf="!editState.video"
                    (click)="saveAttributes(v, 'video', 0)"
                    label="Save Changes  "
                    [primary]="true"
                    [iconLeft]="'save'"
                  >
                  </app-button-primary>
                </div>
                <!-- <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(v, 'video', 0)"
                  *ngIf="!disabled"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button> -->
                <app-button-primary
                  (click)="remove(v, 'video')"
                  label="Remove Video #{{ i + 1 }}"
                  [outlineDanger]="true"
                  [iconLeft]="'delete'"
                >
                </app-button-primary>
                <!-- <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(v, 'video')"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button> -->
              </div>

              <div class="d-flex" style="border-top: 1px solid #ccc">
                <div class="w-100 bg-main">
                  <p>Adapter</p>
                </div>
                <div class="w-100">
                  <input
                    type="text"
                    name="videoAdapter{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="v.videoadapter"
                    [readonly]="editState.video"
                    [class.readonly-input]="editState.video"
                  />
                </div>
              </div>
            </div>
          </div>

          <!--<div>
            <div class="card card-body">

                <h2 class="card-label">
                  <b>
                    Device Information:
                  </b>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="editMode()">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="saveAttributes()" *ngIf="!disabled" >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>System Manufacturer</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="systemManufacturer" class="form-control fctrl" [(ngModel)]="inventory.systemManufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>System Product Name</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="systemProductName" class="form-control fctrl" [(ngModel)]="inventory.systemProductName" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>System Chassis Type</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="systemChassisType" class="form-control fctrl" [(ngModel)]="inventory.systemChassisType" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>System Serial Number</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="systemSerialNumber" class="form-control fctrl" [(ngModel)]="inventory.systemSerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>PO Number</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="poNumber" class="form-control fctrl" [(ngModel)]="inventory.poNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processing Date</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processingDate" class="form-control fctrl" [(ngModel)]="inventory.processingDate" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processing Time</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processingTime" class="form-control fctrl" [(ngModel)]="inventory.processingTime" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Pxe Profile</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="pxeProfile" class="form-control fctrl" [(ngModel)]="inventory.pxeProfile" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Manufacturer</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorManufacturer" class="form-control fctrl" [(ngModel)]="inventory.processorManufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Information</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorInformation" class="form-control fctrl" [(ngModel)]="inventory.processorInformation" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Model</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorModel" class="form-control fctrl" [(ngModel)]="inventory.processorModel" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Type</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorType" class="form-control fctrl" [(ngModel)]="inventory.processorType" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Speed</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorSpeed" class="form-control fctrl" [(ngModel)]="inventory.processorSpeed" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Cores</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorCores" class="form-control fctrl" [(ngModel)]="inventory.processorCores" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Processor Serial Number</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="processorSerialNumber" class="form-control fctrl" [(ngModel)]="inventory.processorSerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Memory Manufacturer</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="memoryManufacturer" class="form-control fctrl" [(ngModel)]="inventory.memoryManufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Memory Model</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="memoryModel" class="form-control fctrl" [(ngModel)]="inventory.memoryModel" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Memory Size</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="memorySize" class="form-control fctrl" [(ngModel)]="inventory.memorySize" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Memory Information</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="memoryInformation" class="form-control fctrl" [(ngModel)]="inventory.memoryInformation" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Memory Speed</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="memorySpeed" class="form-control fctrl" [(ngModel)]="inventory.memorySpeed" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Memory Serial Number</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="memorySerialNumber" class="form-control fctrl" [(ngModel)]="inventory.memorySerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Video Adapter</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="videoAdapter" class="form-control fctrl" [(ngModel)]="inventory.videoAdapter" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Network Adapter</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="networkAdapter" class="form-control fctrl" [(ngModel)]="inventory.networkAdapter" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Optical Device</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="opticalDevice" class="form-control fctrl" [(ngModel)]="inventory.opticalDevice" [readonly] = "disabled">
                  </div>
                </div>
            </div>
          </div>

          <div>
            <div class="card card-body">

                <h2 class="card-label">
                  <b>
                    Drive Information:
                  </b>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="editMode()">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="saveAttributes()" *ngIf="!disabled" >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Manufacturer</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="Manufacturer" class="form-control fctrl" [(ngModel)]="inventory.Manufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Model</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="Model" class="form-control fctrl" [(ngModel)]="inventory.Model" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Capacity</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="Capacity" class="form-control fctrl" [(ngModel)]="inventory.Capacity" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Form Factor</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="FormFactor" class="form-control fctrl" [(ngModel)]="inventory.FormFactor" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Device Summary</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="deviceSummary" class="form-control fctrl" [(ngModel)]="inventory.deviceSummary" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Smart Power On Hours</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="smartPowerOnHours" class="form-control fctrl" [(ngModel)]="inventory.smartPowerOnHours" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Serial Number</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="SerialNumber" class="form-control fctrl" [(ngModel)]="inventory.SerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Serial Number New</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="SerialNumber_new" class="form-control fctrl" [(ngModel)]="inventory.SerialNumber_new" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Grade</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="grade" class="form-control fctrl" [(ngModel)]="inventory.grade" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Block Size</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="BlockSize" class="form-control fctrl" [(ngModel)]="inventory.BlockSize" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>RPM</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="RPM" class="form-control fctrl" [(ngModel)]="inventory.RPM" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Health Score</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="HealthScore" class="form-control fctrl" [(ngModel)]="inventory.HealthScore" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Reallocated Sectors</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="ReallocatedSectors" class="form-control fctrl" [(ngModel)]="inventory.ReallocatedSectors" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure Summary</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureSummary" class="form-control fctrl" [(ngModel)]="inventory.erasureSummary" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure Method</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureMethod" class="form-control fctrl" [(ngModel)]="inventory.erasureMethod" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure Results</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureResults" class="form-control fctrl" [(ngModel)]="inventory.erasureResults" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure Duration</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureDuration" class="form-control fctrl" [(ngModel)]="inventory.erasureDuration" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure Start Date</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureStartDate" class="form-control fctrl" [(ngModel)]="inventory.erasureStartDate" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure Start Time</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureStartTime" class="form-control fctrl" [(ngModel)]="inventory.erasureStartTime" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure End Time</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureEndTime" class="form-control fctrl" [(ngModel)]="inventory.erasureEndTime" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Erasure End Date</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="erasureEndDate" class="form-control fctrl" [(ngModel)]="inventory.erasureEndDate" [readonly] = "disabled">
                  </div>
                </div>
            </div>
          </div>

          <div>
            <div class="card card-body">

                <h2 class="card-label">
                  <b>
                    Testing Information:
                  </b>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="editMode()">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="saveAttributes()" *ngIf="!disabled" >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Battery Information</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="batteryInformation" class="form-control fctrl" [(ngModel)]="inventory.batteryInformation" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Battery Capacity</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="batteryCapacity" class="form-control fctrl" [(ngModel)]="inventory.batteryCapacity" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Battery Full Charge</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="batteryFullCharge" class="form-control fctrl" [(ngModel)]="inventory.batteryFullCharge" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Battery Life</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="batteryLife" class="form-control fctrl" [(ngModel)]="inventory.batteryLife" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Battery Grade</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="batteryGrade" class="form-control fctrl" [(ngModel)]="inventory.batteryGrade" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Burnin In Results Cpu</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="burninInResultsCpu" class="form-control fctrl" [(ngModel)]="inventory.burninInResultsCpu" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Burnin In Results Memory</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="burninInResultsMemory" class="form-control fctrl" [(ngModel)]="inventory.burninInResultsMemory" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>System Condition Grade</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="systemConditionGrade" class="form-control fctrl" [(ngModel)]="inventory.systemConditionGrade" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Missing Parts Answer 1</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="missingPartsAnswer1" class="form-control fctrl" [(ngModel)]="inventory.missingPartsAnswer1" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Physical Grading Answer 2</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="physicalGradingAnswer2" class="form-control fctrl" [(ngModel)]="inventory.physicalGradingAnswer2" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Screen Grading Answer 3</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="screenGradingAnswer3" class="form-control fctrl" [(ngModel)]="inventory.screenGradingAnswer3" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Computrace Test Results</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="computraceTestResults" class="form-control fctrl" [(ngModel)]="inventory.computraceTestResults" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Ata Gradle File</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="ataGradleFile" class="form-control fctrl" [(ngModel)]="inventory.ataGradleFile" [readonly] = "disabled">
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Scsi Gradle File</p>
                  </div>
                  <div class=" w-100">
                    <input type="text" name="scsiGradleFile" class="form-control fctrl" [(ngModel)]="inventory.scsiGradleFile" [readonly] = "disabled">
                  </div>
                </div>
            </div>
          </div>-->

          <!-- <div *ngIf="!deepSearch" style="text-align: right">
            <button (click)="back()" class="btn btn-default btn-sm">
              <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back to
              detail
            </button>
          </div> -->
        </div>
        <!-- end div -->
        <!-- bitraserdata -->
        <div *ngIf="bitrasershow && sectionShown === 'bitraser'">
          <div *ngIf="!loading">
            <div>
              <div
                class="card card-body"
                *ngFor="let s of raserhardware; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> System Information: </b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Manufacturer</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemManufacturer{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.manufacturer"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Model</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemModel{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.model"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Serial Number</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemSerialNumber{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.systemSerial"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>SKU</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemSKU{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.skuNumber"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Processor Information</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemField2{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.field2"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Memory Information</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemField3{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.MemoryRam"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Autopilot Status</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="systemField3{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="s.autopilotStatus"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div [ngClass]="raserdisk?.length > 1 ? 'gridContainerTwo' : ''">
              <div
                class="card card-body"
                *ngFor="let hdd of raserdisk; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> HDD #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Model</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddModel{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.diskModel"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Serial Number</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddSerialnumber{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.diskSerial"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Capacity</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddCapacity{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.diskSize"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Block Size</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddBlocksize{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.SectorSize"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Form Factor</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddFormfactor{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.Interface"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Device Type</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddDevicetype{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.MediaType"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Erasure Method</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddErasuremethod{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.erasureMethod"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Erasure Results</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddErasedResult{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.ErasedResult"
                      readonly
                      style="font-size: 20px; font-weight: 900"
                      [ngClass]="{
                        'color-green': hdd.ErasedResult === 'PASSED',
                        'color-orange': hdd.ErasedResult === 'PARTIAL',
                        'color-red': hdd.ErasedResult === 'FAILED',
                        'color-red-d': hdd.ErasedResult === 'DESTROYED',
                        'color-red-r': hdd.ErasedResult === 'REMOVED',
                      }"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Erasure Start Date</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddErasurestartdate{{ i + 1 }}"
                      class="form-control fctrl"
                      readonly
                      [value]="hdd.start | date: 'MM/dd/yyyy'"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Erasure Start Time</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddErasurestarttime{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.startTime"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Erasure End Date</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddErasureenddate{{ i + 1 }}"
                      class="form-control fctrl"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                      [value]="hdd.end | date: 'MM/dd/yyyy'"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Erasure End Time</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="hddErasureendtime{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="hdd.endTime"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              [ngClass]="raserprocessor?.length > 1 ? 'gridContainerTwo' : ''"
            >
              <div
                class="card card-body"
                *ngFor="let cpu of raserprocessor; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> CPU #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Manufacturer</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="cpuManufacturer{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="cpu.manufacturer"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Model</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="cpuModel{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="cpu.version_ModelName"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Serial Number</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="cpuSerialNumber{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="cpu.processorID"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Processor Speed</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="cpuField1{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="cpu.currentClockSpeed"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Processor Cores</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="cpuField2{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="cpu.coreEnabled"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div [ngClass]="rasermemory?.length > 1 ? 'gridContainerTwo' : ''">
              <div
                class="card card-body"
                *ngFor="let memory of rasermemory; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> Memory #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Manufacturer</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="memoryManufacturer{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="memory.manufacturer"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Memory Size</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="memoryField1{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="memory.field1"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Memory Speed</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="memoryField2{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="memory.field2"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Memory Type</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="memoryType{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="memory.memorytype"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              [ngClass]="
                raserhardwaretest?.length > 1 ? 'gridContainerTwo' : ''
              "
            >
              <div
                class="card card-body"
                *ngFor="let t of raserhardwaretest; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> Testing #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>CPU</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="testingCPU{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="t.cpuStatus"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Memory</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="testingMemory{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="t.memoryStatus"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Battery</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="testingBattery{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="t.batteryStatus"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>

                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Optical Device</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="testingOpticalDevice{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="t.opticalDriveStatus"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div [ngClass]="raserbatery?.length > 1 ? 'gridContainerTwo' : ''">
              <div
                class="card card-body"
                *ngFor="let battery of raserbatery; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> Battery #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Manufacturer</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batteryManufacturer{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="battery.manufacturer"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Model</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batteryModel{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="battery.model"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Serial Number</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batterySerialNumber{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="battery.serial"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Battery Chemistry</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batteryField1{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="battery.type"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Battery Capacity</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batteryField3{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="battery.current"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Battery Full Charge</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batteryField4{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="battery.full"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Battery Life</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="batteryField5{{ i + 1 }}"
                      class="form-control fctrl"
                      [value]="battery.health + ' %'"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div [ngClass]="rasernetwork?.length > 1 ? 'gridContainerTwo' : ''">
              <div
                class="card card-body"
                *ngFor="let network of rasernetwork; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> Network #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Adapter</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="networkAdapter{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="network.model"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div [ngClass]="raservideo?.length > 1 ? 'gridContainerTwo' : ''">
              <div
                class="card card-body"
                *ngFor="let v of raservideo; let i = index"
              >
                <h2 class="card-label mb-2">
                  <b> Video Adapter #{{ i + 1 }} Information:</b>
                </h2>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class="w-100 bg-main">
                    <p>Adapter</p>
                  </div>
                  <div class="w-100">
                    <input
                      type="text"
                      name="videoAdapter{{ i + 1 }}"
                      class="form-control fctrl"
                      [(ngModel)]="v.videoAdapter"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- endbitraser -->
        <div *ngIf="phonecheckshow && sectionShown === 'phonecheck'">
          <div *ngIf="!loading">
            <div>
              <div>
                <div class="card card-body">
                  <h2 class="card-label">
                    <b> Mobile Information: </b>
                  </h2>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Manufacturer</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="systemManufacturer"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.manufacturer"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Model</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="systemModel"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.model"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Serial Number</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="systemSerialNumber"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.serial"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Model No</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="systemSKU"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.modelNo"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Model #</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="systemField2"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.modelNumber"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Memory Information</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="systemField3"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.memory"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>OS</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="os"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.oS"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>IMEI</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="iMEI"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.iMEI"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Color</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="color"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.color"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Carrier</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="carrier"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.carrier"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Country Origin</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="contryOrigin"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.contryOrigin"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Battery Health %</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="battery"
                        [value]="phonecheckinfo.battery + ' %'"
                        class="form-control fctrl"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Device Lock</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="deviceLock"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.deviceLock"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Unlock Status</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="unlockStatus"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.unlockStatus"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>MDM</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="mDM"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.mDM"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Grade</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="grade"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.grade"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Erased</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="erased"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.erased"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Erased Type</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="erasedType"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.erasedType"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>PO#-Batch#</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="invoiceNo"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.invoiceNo"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Vendor Name</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="vendorName"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.vendorName"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                  <div class="d-flex" style="border-top: 1px solid #ccc">
                    <div class="w-100 bg-main">
                      <p>Tester Name</p>
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="testerName"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.testerName"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   <div>
              <div
                class="card card-body"
                *ngIf="phonecheckinfo"
              >
                <h2 class="card-label">
                  <b> Parts: </b>
                </h2>
              <div
                class="card card-body"
                *ngFor="let v of phonecheckpart; let i = index"
              >
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Name</p>
                  </div>
                  <div class=" w-100">
                    <input
                      type="text"
                      name="name"
                      class="form-control fctrl"
                      [(ngModel)]="v.name"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
                <div class="d-flex" style="border-top: 1px solid #ccc">
                  <div class=" w-100 bg-main">
                    <p>Status</p>
                  </div>
                  <div class=" w-100">
                    <input
                      type="text"
                      name="Status"
                      class="form-control fctrl"
                      [(ngModel)]="v.Status"
                      [readonly]="disabled"
                      [class.readonly-input]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>
            </div>  -->
            <div *ngIf="phonecheckpart?.length">
              <div>
                <div class="card card-body" *ngIf="phonecheckinfo">
                  <h2 class="card-label">
                    <b>Parts:</b>
                  </h2>
                  <div
                    *ngFor="let v of phonecheckpart; let i = index"
                    class="d-flex"
                    style="border-top: 1px solid #ccc"
                  >
                    <div class="w-100 bg-main">
                      <p>{{ v.name }}</p>
                      <!-- <input
                        type="text"
                        name="name"
                        [(ngModel)]="v.name"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      /> -->
                    </div>
                    <div class="w-100">
                      <input
                        type="text"
                        name="Status"
                        [(ngModel)]="v.Status"
                        [readonly]="disabled"
                        [class.readonly-input]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- endphonecheck -->
      </div>
    </div>
  </div>
</div>
